import React from 'react';
import useTranslate from '../../../customHooks/useTranslate';

interface TitleProps {
    as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    className?: string;
    text: string;
    translated?: boolean;
}

const Title = (props: TitleProps) => {
    const { as: Component = 'h2', className, text, translated = true } = props;
    const translatedText = useTranslate(text);
    return (
        <Component
            className={`property__title text-overflow-ellipsis ${
                className || ''
            }`}
        >
            {translated ? translatedText : text}
        </Component>
    );
};

export default Title;
